import React from 'react'
import './Footer.css';
import podium_logo from './pics/Podium_Finish_Logo.png';
import airrosti_logo from './pics/airrosti_whiteback.png';
import dog_logo from './pics/dogspeed_white.png';
import drip_logo from './pics/Drip_Drive_whiteback.png';
import hunt_logo from './pics/HUNTComPNG.png';
import kogel_logo from './pics/Kogel_White_Logo.png';
import masEP_logo from './pics/MASEP_new.png';
import pollo_logo from './pics/POLLO_LOGO_ORIGINAL.svg';
import bmba_logo from './pics/sponsor-bmba.png';
import crazy_logo from './pics/crazycat_logo.png';
import handske_logo from './pics/sponsor-handske.png';
import merol_logo from  './pics/sponsor-merol.svg';
import shock_logo from './pics/The_shock_lab_black_logo.svg';
import merol_racing from './pics/merolracing.svg';
import blackground_geo from './pics/black-geometric-wallpaper.jpg';
import websites_elpaso from './pics/websites-elpaso-logo.png';
import BenEKeith from './pics/benEkeithsponsor.svg';
import BorderBikes from './pics/border_bikes_logo.png';
import HustleBikes from './pics/hustle-labs-facebook.png';
import BlackOx from './pics/blackOx.png';
import Gabe from './pics/gabriel-perez.jpg';
import Max from './pics/max_tint.png'
import Handup from './pics/hand_up.png'
//import Onin_Staffing from './pics/Onin_Staffing.png';

/*

 <div className="col-4">
                        <a href="https://www.huntcompanies.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>
     <div className="col-4">
                    <a href="http://www.bmbaelpaso.org/"  target="_blank"><img src={bmba_logo} className="logo-image" alt="Logo" /></a>
                </div>

      
            <div className="row">
                <div className="col-4">
                    <a href="https://www.handskegloves.com/"  target="_blank"><img src={handske_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.merolracing.com/"  target="_blank"><img src={merol_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.dogspeedco.com/"  target="_blank"><img src={dog_logo} className="logo-image" alt="Logo" /></a>
                </div>
            </div>

             <div className="row">
                <div className="col-4">
                    <a href="https://www.airrosti.com/location/Texas/SUMM/"  target="_blank"><img src={airrosti_logo} className="logo-image" alt="Logo" /></a>
                </div>
              
                <div className="col-4">
                    <a href="https://podiumfinishsportcafe.com/"  target="_blank"><img src={podium_logo} className="logo-image" alt="Logo" /></a>
                </div>
            </div>

            <div className="row">
                <div className="col-4">
                        <a href="https://crazycatcyclery.com/"  target="_blank"> <img src={crazy_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.dripdriveiv.com/"  target="_blank">  <img src={drip_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.facebook.com/maselpaso"  target="_blank">   <img src={masEP_logo} className="logo-image" alt="Logo" /></a>
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <a href="https://www.kogel.cc/"  target="_blank"> <img src={kogel_logo} className="logo-image" alt="Logo" /></a>
                </div>
                
            </div>





            //NEW

              <div className="row">
            <div className="col-4">
                    <a href="https://www.airrosti.com/location/Texas/SUMM/"  target="_blank"><img src={airrosti_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.oninstaffing.com/branches/ELPO/"  target="_blank"><img src={Onin_Staffing} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.kogel.cc/"  target="_blank"> <img src={kogel_logo} className="logo-image" alt="Logo" /></a>
                </div>
            </div>


            <div className="col-4">
                    <a href="https://www.borderbicycle.com/"  target="_blank"><img src={BorderBikes} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                        <a href="https://www.huntcompanies.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://www.dogspeedco.com/"  target="_blank"><img src={dog_logo} className="logo-image" alt="Logo" /></a>
                </div>

                 <div className="col-4">
                    <a href="https://www.dripdriveiv.com/"  target="_blank">  <img src={drip_logo} className="logo-image" alt="Logo" /></a>
                </div>

*/

export default function Footer() {
    return (
    <div className="footer-enduro" style={{ backgroundImage: `url(${blackground_geo})` }} >
        <div className="container">
            
            <div className="row">

                    <div className="col-4">
                        <a href="https://www.merolracing.com/"  target="_blank"><img src={merol_logo} className="logo-image" alt="Logo" /></a>
                    </div>
                
                    <div className="col-4">
                        <h1 className="rockbiter-race">Sponsors  </h1>
                    </div>

                    <div className="col-4">
                        <a href="https://www.merolracing.com/"  target="_blank"><img src={merol_logo} className="logo-image" alt="Logo" /></a>
                    </div>
            </div>
        
     

           <div className="row">
                <div className="col-4">
                        <a href="https://www.huntcompanies.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                        <a href="https://www.huntcompanies.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                        <a href="https://www.huntcompanies.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>
                
                
            </div>
            

             <div className="row">
                  
                <div className="col-4">
                    <a href="https://www.theshocklab.com/"  target="_blank"><img src={shock_logo} className="logo-image" alt="Logo" /></a>
                </div>

                 <div className="col-4">
                    <a href="https://gabrielsperezlaw.com/"  target="_blank"><img  src={Gabe} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://www.facebook.com/MaxLasTorresJuarez/"  target="_blank"><img  src={Max} className="logo-image" alt="Logo" /></a>
                </div>

                
           
            </div>

            <div className="row">
            
              
                <div className="col-4">
                    <a href="http://www.bmbaelpaso.org/"  target="_blank"><img src={bmba_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                        <a href="https://crazycatcyclery.com/"  target="_blank"> <img src={crazy_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://www.benekeith.com/beverage/"  target="_blank"><img src={BenEKeith} className="logo-image" alt="Logo" /></a>
                </div>
                
            </div>
      
            <div className="row">
                <div className="col-4">
                    <a href="https://www.handskegloves.com/"  target="_blank"><img src={handske_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://hustlebikelabs.com/"  target="_blank"><img src={HustleBikes} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://podiumfinishsportcafe.com/"  target="_blank"><img src={podium_logo} className="logo-image" alt="Logo" /></a>
                </div>
               
                
            </div>

            <div className="row">

                
                
                

                <div className="col-4">
                    <a href="https://blackoxsealant.com/"  target="_blank"><img src={BlackOx} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://handupgloves.com/"  target="_blank"><img src={Handup} className="logo-image" alt="Logo" /></a>
                </div>

              
               
            </div>
            
          

           
           
           
         

           

            <div id ="bottom-lines" className="row">
               
                
                
                <div className="col-sm-6">
                    <p id='copyright'>Copyright © 2023 MEROL RACING LLC. All rights reserved.</p>
                </div>


                <div className="col-sm-6">
                    <p id='websites-elpaso'>Designed and Developed by Will Palafox </p>
                </div>

                
                
            </div>

            
        
        
        
        
         </div>
    </div>
    )
}


/*


            <div className="row">
                <div className="col-4">
                        <a href="https://podiumfinishsportcafe.com/"  target="_blank"><img src={podium_logo} className="logo-image" alt="Logo" /></a>
                    </div>
                <div className="col-4">
                    <a href="https://pollofelizjrz.com/"  target="_blank"><img src={pollo_logo} className="logo-image" alt="Logo" /></a>
                </div>
                
                
                
                
                
                <div className="col-4">
                    <a href="https://www.theshocklab.com/"  target="_blank"><img src={shock_logo} className="logo-image" alt="Logo" /></a>
                </div>
           
            </div>
           

            <div className="row">
                <div className="col-4">
                    <a href="https://www.handskegloves.com/"  target="_blank"><img src={handske_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                        <a href="https://www.huntcommunities.com/"  target="_blank"> <img src={hunt_logo} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-4">
                    <a href="https://www.crazycatcyclery.com"  target="_blank"><img src={crazy_cat_logo} className="logo-image" alt="Logo" /></a>
                </div>
        
            </div>

            <div className="row">
                
               
                <div className="col-4">
                    <a href="https://www.facebook.com/maselpaso"  target="_blank">   <img src={masEP_logo} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="https://www.benekeith.com/beverage/"  target="_blank"><img src={BenEKeith} className="logo-image" alt="Logo" /></a>
                </div>
                <div className="col-4">
                    <a href="http://www.bmbaelpaso.org/"  target="_blank"><img src={bmba_logo} className="logo-image" alt="Logo" /></a>
                </div>
            </div>

            <div className="row">
                
               
                <div className="col-6">
                    <a href="https://hustlebikelabs.com/"  target="_blank"><img src={HustleBikes} className="logo-image" alt="Logo" /></a>
                </div>

                <div className="col-6">
                    <a href="https://blackoxsealant.com/"  target="_blank"><img src={BlackOx} className="logo-image" alt="Logo" /></a>
                </div>
               
            </div>

            */